import { h } from "omi";

import { IconProps } from "../icons.ts";

export function NextWorkIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={props.width} height={props.height} viewBox="0 0 19 20">
      <g clip-path="url(#a)" fill="#040405">
        <path d="M5.465 12.877 3.624 8.17 1.648 7.3l-.238 6.842 1.576.69.156-4.272 1.823 5.138 1.975.86.239-6.835-1.58-.69-.134 3.844Z" />
        <path d="M18.644 4.56h-.003L10.032.848.652 4.139l8.895 3.836.02.007-.384 10.98 9.207-3.23.388-11.112-.134-.056V4.56ZM16 14.713l-1.486.534-.227-2.318-.397 2.546-1.483.535-.87-5.97 1.237-.446.565 3.47.596-3.89.962-.345.333 3.54.825-3.956 1.263-.455-1.315 6.755H16Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="rotate(2 -14.64 22.53)" d="M0 0h18.133v18.133H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
